import { React, _n } from 'pexui';
import { get } from 'lodash';
import globals from '../../models/globals';
import { DocUploadService } from '../../services/docuploadsvc';
import { flow, getTrackLabel } from '../../models/flow';
import { getIsDtm, getQuestionNumber } from '../../utilities/track';
import { getDtmHierarchy } from '../../utilities/dtm';

export class YodleeForm extends React.Component {
  constructor(props) {
    super(props);
    this.fetchYodleeAttributes = this.fetchYodleeAttributes.bind(this);
  }

  componentDidMount() {
    this.props.addSpinner();
    this.fetchYodleeAttributes();
  }

  fetchYodleeAttributes() {
    return DocUploadService.getYodleeAttributes(flow.req)
      .then(({
        isRecurr,
        yodleeAttributes,
        providerSpecifics,
        additionalYodleeParams
      }) => {
        flow.isRecurr = isRecurr;
        this.refs.yodleeInput.value = yodleeAttributes;

        if (providerSpecifics) {
          providerSpecifics.map(({ param_name, param_value }, i) => {
            const input = (
              <input
                type="hidden"
                name={param_name}
                id={`provider-specifics-input-${param_name}-${i}`}
                value={param_value}
              />
            );
            this.refs.yodleeForm.appendChild(input);
          });
        }

        if (additionalYodleeParams) {
          const additionalParams = additionalYodleeParams
            .map(({ name, value }) => `&${name}=${value}`)
            .join('');


          this.refs.extraParams.value = `${this.refs.extraParams.value}${additionalParams}`;
        }

        this.refs.yodleeForm.submit();
      })
      .catch((err) => {
        const errorKey = 'Yodlee.failed.message';

        flow.lastError = 'failed';
        flow.addMessage(`!${_n(errorKey)}`, errorKey);
        flow.widget.nav('index');
      });
  }

  render() {
    const { origin } = window.location;
    const { yodleeNonSSOActionURL } = globals.config;
    const yodleeErrorOption2 = 'postSource=usecase_1';
    const pcn = get(flow, 'req.document_data.process_control_number', 0);
    const countryCode = get(flow, 'req.market', 0);
    const tabName = get(flow, 'currNode', 0);
    const questionNumber = getQuestionNumber(flow.currNode);
    const parentPageHierarchy = getDtmHierarchy(countryCode) || 0;
    const isDtm = getIsDtm();
    // ITAG requires tabName, but DTM requires questionNumber
    const extraParams = [
      `callback=${this.props.callbackUri}&${yodleeErrorOption2}&ssoDomain=`,
      `${this.props.ssodomain}&dynamicVal=${pcn}~~${countryCode}~~${isDtm ? questionNumber : tabName}~~`,
      `${parentPageHierarchy}~~0&locationurl=${origin}`,
    ].join('');
    const action = yodleeNonSSOActionURL;
    // render yodlee form
    return (
      <form
        id="y_form"
        ref="yodleeForm"
        name="samlPost"
        method="post"
        target="y_iframe"
        action={action}
      >
        <input
          ref="extraParams"
          type="hidden"
          name="extraParams"
          id="extraParams"
          value={extraParams}
        />
        <input
          type="hidden"
          name="issuerId"
          id="issuerId"
          value="getinfowidget"
        />
        <input
          ref="yodleeInput"
          type="hidden"
          name='samlResponse'
          id='samlResponse'
        />
        <input
          type="hidden"
          name="locale"
          value={this.props.locale}
        />
      </form>
    );
  }
}



// WEBPACK FOOTER //
// ./application/src/views/yodlee/yodleeForm.jsx